import { createApiClient } from '../config/base-api';
import { Feature } from '../models/features/features';

/**
 * Patron server API client
 * Headers are set in index.tsx setRequestDefaults()
 */
export const patron = createApiClient();

type BooleanFeatureFlags = Omit<typeof Feature, 'INBOX_MAINTENANCE'>;
export type FeatureFlagFetchResponse = {
  [K in BooleanFeatureFlags[keyof BooleanFeatureFlags]]: boolean;
} & {
  [Feature.INBOX_MAINTENANCE]: string;
};

export class FeatureFlagsService {
  private url: string;

  constructor() {
    const patronDefaultHostname = import.meta.env.VITE_APP_PATRON_DOMAIN;
    const customDomain = window.location.hostname !== patronDefaultHostname;
    const pathRegex = /^\/([^/]*)\/([^/]*)\/?/;

    if (customDomain) {
      this.url = `/features`;
    } else {
      const matches = pathRegex.exec(window.location.pathname);
      if (!matches || matches.length < 3) {
        throw new Error('Unable to parse program slugs from url');
      }
      const brandSlug = matches[1];
      const programSlug = matches[2];

      this.url = `/${brandSlug}/${programSlug}/features`;
    }
  }

  public async fetch() {
    return (await patron.get<FeatureFlagFetchResponse>(this.url)).data;
  }
}
